import { setSelectedOrderItemKeys } from '../../../State/selectedOrderItemKeys';
import { setShowEditOrderItemModal } from '../../../State/showEditOrderItemModal';

export default ({ orderIndex, orderGroupIndex, orderItemIndex, orderItemId }) => async (dispatch) => {

  dispatch(setSelectedOrderItemKeys({ orderIndex, orderGroupIndex, orderItemIndex, orderItemId }));
  dispatch(setShowEditOrderItemModal(true));

}